import { cart, checkout, combo, user, shippingModel } from 'core/use-cases';

/**
 * This list of messages for handling failure notifications
 *
 */
export const failure = {
  [shippingModel.actions.availableDeliveryModesFetch.failure.type]:
    'Tivemos um problema ao carregar seus modelos de entrega disponíveis. Tente novamente mais tarde.',
  [shippingModel.actions.currentDeliveryModeFetch.failure.type]:
    'Tivemos um problema ao selecionar seu modelo de entrega. Tente novamente.',
  [cart.actions.cartFetch.failure.type]:
    'Não conseguimos inicializar o carrinho. Tente recarregar a página.',
  [cart.actions.lastCartFetch.failure.type]:
    'Não conseguimos inicializar o carrinho. Tente recarregar a página.',
  [cart.actions.cartCurrentDeliveryFetch.failure.type]:
    'Não conseguimos inicializar o carrinho. Tente recarregar a página.',
  [cart.actions.cartFetchForGiftsCheck.failure.type]:
    'Não conseguimos inicializar o carrinho. Tente recarregar a página.',
  [cart.actions.cartSetShippingModelFetch.failure.type]:
    'Tivemos um problema ao selecionar seu modelo de entrega. Tente novamente.',
  [cart.actions.clearCouponFetch.failure.type]:
    'Tivemos um erro ao tentar excluir o cupom ou vale-brinde. Por favor, tente novamente.',
  [cart.actions.itemAddFetch.failure.type]:
    'O produto {productCode} não tem mais estoque. Se quiser, você pode receber um aviso quando ele retornar',
  [cart.actions.itemDeleteFetch.failure.type]: 'Não conseguimos remover este produto.',
  [cart.actions.itemUpdateFetch.failure.type]: 'Não conseguimos atualizar este produto.',
  [cart.actions.setCouponFetch.failure.type]:
    'Tivemos um erro ao tentar adicionar o cupom ou vale-brinde. Por favor, tente novamente.',
  [checkout.actions.paymentDetailFetch.failure.type]:
    'Não foi possível finalizar o pedido. Por favor, tente novamente.',
  [combo.actions.comboFetch.failure.type]: 'O combo {comboCode} está sem estoque neste momento.',
  [combo.actions.comboPost.failure.type]:
    'Não foi possível adicionar o produto ao carrinho. Por favor, tente novamente.',
  [checkout.actions.promotionFetch.failure.type]:
    'Não foi possível escolher brindes. Por favor, recarregue a página e selecione novamente seus brindes.',
  [user.actions.cyclesFetch.failure.type]:
    'No momento não foi possível carregar as informações de ciclo.',
};
